import Container from './LicenseBatchEdit.container';
import LicenseBatchEdit from './LicenseBatchEdit';

export default Container(LicenseBatchEdit);
